import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { AccountPageWrapper } from "../AccountPageWrapper";
import { Card, Stack, StackSeparator, Text } from "@chakra-ui/react";
import { AddUserInput } from "./AddUserInput";
import { t } from "i18next";
import { AccountUserItem } from "./AccountUserItem";
import { AccountView } from "../../models/AccountView";
import { useStores } from "../../../shared/stores/RootStore";
import { useParams } from "react-router-dom";

const AccountUsersPageBase: React.FC = () => {
  const accountId = useParams().accountId!;
  const { accountStore, authStore } = useStores();

  const initialLoad = async () => {
    accountStore.resetAccountManagement();
    await accountStore.fetchAccountUsers(accountId);
  };

  useEffect(() => {
    initialLoad();
    // eslint-disable-next-line
  }, [accountId]);

  return (
    <AccountPageWrapper selectedView={AccountView.Users} accountId={accountId}>
      <Text mx={6} fontSize="2xl">
        {t(`account:Users.tab`)}
      </Text>
      <AddUserInput />
      <Card.Root mx={6}>
        <Stack gap={0} separator={<StackSeparator />}>
          {accountStore.accountUsers.map((au, i) => (
            <AccountUserItem
              key={i}
              accountUser={au}
              me={authStore.userEmail === au.email}
            />
          ))}
        </Stack>
      </Card.Root>
    </AccountPageWrapper>
  );
};

export const AccountUsersPage = observer(AccountUsersPageBase);
